import React from "react";

export default function RegistrationOverSection({ t, props }: any) {
  return (
    <section id="register" className="about-drimrun-section">
      <h2>
        {t.registrationOver.title}
      </h2>
    </section>  
  );
}
